import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { VatSummary } from '../document/vat-summary';
import { InventoryDocumentKind } from './inventory-document-kind';
import { InventoryGoodsIssueDocumentModel } from './inventory-goods-issue-document.model';

@CopyMetadataFromParent()
export class InventoryGoodsIssueAdjustmentDocumentModel extends InventoryGoodsIssueDocumentModel {
    @Property()
    public adjustedDocumentId: number;

    @Property()
    public adjustedDocumentVersion: string;

    @Property()
    public override readonly kind: InventoryDocumentKind = InventoryDocumentKind.GoodsIssueAdjustment;

    public vatSummary: VatSummary;
}
